<form *ngIf="currentSettings && entity" [formGroup]="settingsForm" [class.fake-hidden]="!showSettings"
  (ngSubmit)="submit()">
  <!--<div class="refresh-settings-pb">
    <div  (click)="refreshSettings($event)"><i class="bi bi-arrow-clockwise"></i></div>
  </div>-->

  <div class="row p-4">
    <div class="col-6">
      <div class="row mb-3">
        <label [for]="'language-' + entity.id" class="col-sm-5 col-form-label">{{ 'COMMON.LANGUAGES.TITLE' | translate
          }}</label>
        <div class="col-sm-7">
          <select class="form-select" [id]="'language-' + entity.id" formControlName="language">
            <option *ngFor="let language of utils.backoffice_languages" [value]="language.value">{{('COMMON.LANGUAGES.' +
              language.name) |translate}}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <!-- from mail is not configurable by optical entity -->
  <!--<div class="row p-4" *ngIf="(entity.entityTypeId === 4 && currentSettings.fromMailConfigurable)">
    <div class="col-6">
      <div class="row mb-3">
        <label [for]="'fromMail-' + entity.id" class="col-sm-5 col-form-label">{{ 'SETTING.FROMMAIL' |
          translate
          }}</label>
        <div class="col-sm-7">
          <input type="text" class="form-text-input" [id]="'fromMail-' + entity.id" formControlName="fromMail"
            [readonly]="user.roleId !==1">
          <hbo-error-message *ngIf="settingsForm.controls.fromMail.invalid"
            [errorMessage]="'VALIDATIONS.INVALID_EMAIL' | translate" [className]="'fileValidation'"></hbo-error-message>
        </div>
      </div>
    </div>
  </div>-->

  <div class="row p-4" *ngIf="entity.entityTypeId !== 4">
    <div class="col-6">
      <h4 class="pb-2 mb-3 border-bottom fw-bold">{{ 'SETTING.LOGIN_PAGE' | translate }}</h4>
      <div class="row mb-3">
        <label [for]="'loginToken-' + entity.id" class="col-sm-5 col-form-label">{{ 'SETTING.LOGINTOKEN' | translate
          }}</label>
        <div class="col-sm-7">
          <input type="text" class="form-control-plaintext" [id]="'loginToken-' + entity.id"
            formControlName="loginToken" readonly>
        </div>
      </div>
      <div class="row mb-3">
        <label [for]="'distributorDomain-' + entity.id" class="col-sm-5 col-form-label">{{ 'SETTING.DISTRIBUTORDOMAIN' |
          translate
          }}</label>
        <div class="col-sm-7">
          <input type="text" class="form-text-input" [id]="'distributorDomain-' + entity.id"
            formControlName="distributorDomain"
            [readonly]="user.roleId !==1 || (!settingsForm.controls.distributorDomainAllow.value && entity.entityTypeId === 3) ">
        </div>
      </div>
      <!--- allow from mail only to admin-->
      <div class="form-check mb-4" *ngIf="user.roleId === 1 && entity.entityTypeId <= 2">
        <input class="form-check-input" type="checkbox" [id]="'distributorDomainAllow-' + entity.id"
          formControlName="distributorDomainAllow">
        <label class="form-check-label" [for]="'distributorDomainAllow-' + entity.id">
          {{ 'SETTING.ALLOWDISTRIBUTORDOMAIN' | translate }}
        </label>
      </div>

      <fieldset class="row mb-3">
        <legend class="col-form-label col-sm-5 pt-0">{{ 'SETTING.MODAL_POSITION' | translate }}</legend>
        <div class="col-sm-7">
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" [id]="'modalPosition1-' + entity.id"
              formControlName="modalPosition" value="left">
            <label class="form-check-label" [for]="'modalPosition1-' + entity.id">{{ 'SETTING.LEFT' | translate
              }}</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" [id]="'modalPosition2-' + entity.id"
              formControlName="modalPosition" value="center">
            <label class="form-check-label" [for]="'modalPosition2-' + entity.id">{{ 'SETTING.CENTER' | translate
              }}</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" [id]="'modalPosition3-' + entity.id"
              formControlName="modalPosition" value="right">
            <label class="form-check-label" [for]="'modalPosition3-' + entity.id">{{ 'SETTING.RIGHT' | translate
              }}</label>
          </div>
        </div>
      </fieldset>

      <fieldset class="row mb-3">
        <legend class="col-form-label col-sm-5 pt-0">{{ 'SETTING.MODAL_COLOR' | translate }}</legend>
        <div class="col-sm-7">
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" [id]="'modalColor1-' + entity.id" formControlName="modalColor"
              value="black">
            <label class="form-check-label" [for]="'modalColor1-' + entity.id">{{ 'SETTING.BLACK' | translate }}</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" [id]="'modalColor2-' + entity.id" formControlName="modalColor"
              value="white">
            <label class="form-check-label" [for]="'modalColor2-' + entity.id">{{ 'SETTING.WHITE' | translate }}</label>
          </div>
        </div>
      </fieldset>

      <fieldset class="row mb-3">
        <legend class="col-form-label col-sm-5 pt-0">{{ 'SETTING.HEADER' | translate }}</legend>
        <div class="col-sm-7">
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" [id]="'header1-' + entity.id" formControlName="header"
              value="transparent">
            <label class="form-check-label" [for]="'header1-' + entity.id">{{ 'SETTING.TRANSPARENT' | translate
              }}</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" [id]="'header2-' + entity.id" formControlName="header"
              value="black">
            <label class="form-check-label" [for]="'header2-' + entity.id">{{ 'SETTING.BLACK' | translate }}</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" [id]="'header3-' + entity.id" formControlName="header"
              value="white">
            <label class="form-check-label" [for]="'header3-' + entity.id">{{ 'SETTING.WHITE' | translate }}</label>
          </div>
        </div>
      </fieldset>

      <fieldset class="row mb-3">
        <legend class="col-form-label col-sm-5 pt-0">{{ 'SETTING.WP_BG' | translate }}</legend>
        <div class="col-sm-7">
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" [id]="'wallpaperBg1-' + entity.id"
              formControlName="wallpaperBg" value="color">
            <label class="form-check-label" [for]="'wallpaperBg1-' + entity.id">{{ 'SETTING.COLOR' | translate
              }}</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" [id]="'wallpaperBg2-' + entity.id"
              formControlName="wallpaperBg" value="image">
            <label class="form-check-label" [for]="'wallpaperBg2-' + entity.id">{{ 'SETTING.IMAGE' | translate
              }}</label>
          </div>
        </div>
      </fieldset>

      <div class="row mb-3">
        <label [for]="'wallpaperColor-' + entity.id" class="col-sm-5 col-form-label">{{ 'SETTING.WP_BGCOLOR' | translate
          }}</label>
        <div class="col-sm-7">
          <input type="color" class="form-control form-control-color" [id]="'wallpaperColor-' + entity.id"
            formControlName="wallpaperColor" value="#000">
        </div>
      </div>

      <div class="row mb-3">
        <label [for]="'wallpaperImage-' + entity.id" class="col-sm-5 col-form-label">
          {{ 'SETTING.WP_IMAGE' | translate }}
          <hbo-field-info-icon fieldName="wallpaperImage"></hbo-field-info-icon>
          <a *ngIf="currentSettings.login.wallpaper.backgroundImage && canEditSettings" (click)="clearImage($event,'wallpaperImage')"
            class="clear-pb"><i class="bi bi-trash"></i></a>
          <a *ngIf="currentSettings.login.wallpaper.backgroundImage"
            (click)="showImage($event, currentSettings.login.wallpaper.backgroundImage)" class="image-link"
            target="_blank" [ngClass]="{'only-image-link':isFormReadOnly}"><i
              class="bi bi-image"></i></a>
        </label>
        <!--<div class="col-sm-7">
          <input type="file" class="form-control" [id]="'wallpaperImage-' + entity.id" formControlName="wallpaperImage">
        </div>-->
        <div *ngIf="currentSettings" class="col-sm-7">
          <div class="input-group custom-file-button flex-row-reverse">
            <label class="label-input-file" [for]="'wallpaperImage'">
              <div>
                <div class="label-input-file-placeholder">
                  {{ actualFilenames['wallpaperImage'] ? actualFilenames['wallpaperImage'] :
                  currentSettings.login.wallpaper.backgroundImage!
                  ?
                  getFileNameFromPath(currentSettings.login.wallpaper.backgroundImage!,'wallpaperImage'):('COMMON.UPLOADIMAGE'
                  | translate)}}
                </div>
                <div class="label-input-file-browse">Browse</div>
              </div>
            </label>
            <!--accept=".png,.jpeg,.jpg"-->
            <input type="file" class="form-control rounded-0" [id]="'wallpaperImage-' + entity.id"
              formControlName="wallpaperImage" (change)="uploadFile($event,'wallpaperImage')">
            <hbo-field-validation fieldName="wallpaperImage"></hbo-field-validation>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <label [for]="'logo1-' + entity.id" class="col-sm-5 col-form-label">
          {{ 'SETTING.LOGO' | translate }} 1
          <hbo-field-info-icon fieldName="webLogo1"></hbo-field-info-icon>
          <a *ngIf="currentSettings.logo[1].image && canEditSettings" (click)="clearImage($event,'logo1')" class="clear-pb"><i
              class="bi bi-trash"></i></a>
          <a *ngIf="currentSettings.logo[1].image" (click)="showImage($event, currentSettings.logo[1].image)"
            target="_blank" class="image-link" [ngClass]="{'only-image-link':isFormReadOnly}"><i
              class="bi bi-image"></i></a>
        </label>
        <!--<div class="col-sm-7">
          <input type="file" class="form-control" [id]="'logo1-' + entity.id" formControlName="logo1">
        </div>-->
        <div *ngIf="currentSettings" class="col-sm-7">
          <div class="input-group custom-file-button flex-row-reverse">
            <label class="label-input-file" [for]="'distributorLogo'">
              <div>
                <div class="label-input-file-placeholder">
                  {{ actualFilenames['logo1'] ? actualFilenames['logo1'] : currentSettings.logo[1].image!
                  ? getFileNameFromPath(currentSettings.logo[1].image!,'logo1'):('COMMON.UPLOADIMAGE' | translate)}}
                </div>
                <div class="label-input-file-browse">Browse</div>
              </div>
            </label>
            <!--accept=".png,.jpeg,.jpg"-->
            <input type="file" class="form-control rounded-0" [id]="'logo1-' + entity.id" formControlName="logo1"
              (change)="uploadFile($event,'logo1')">
            <hbo-field-validation fieldName="logo1"></hbo-field-validation>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <label [for]="'logo2-' + entity.id" class="col-sm-5 col-form-label">
          {{ 'SETTING.LOGO' | translate }} 2
          <hbo-field-info-icon fieldName="webLogo2"></hbo-field-info-icon>
          <a *ngIf="currentSettings.logo[2].image && canEditSettings" (click)="clearImage($event,'logo2')" class="clear-pb"><i
              class="bi bi-trash"></i></a>
          <a *ngIf="currentSettings.logo[2].image" (click)="showImage($event, currentSettings.logo[2].image)"
            target="_blank" class="image-link" [ngClass]="{'only-image-link':isFormReadOnly}"><i
              class="bi bi-image"></i></a>
        </label>
        <!--<div class="col-sm-7">
          <input type="file" class="form-control" [id]="'logo2-' + entity.id" formControlName="logo2">
        </div>-->
        <div *ngIf="currentSettings" class="col-sm-7">
          <div class="input-group custom-file-button flex-row-reverse">
            <label class="label-input-file" [for]="'distributorLogo'">
              <div>
                <div class="label-input-file-placeholder">
                  {{ actualFilenames['logo2'] ? actualFilenames['logo2'] : currentSettings.logo[2].image!
                  ? getFileNameFromPath(currentSettings.logo[2].image!,'logo2'):('COMMON.UPLOADIMAGE' | translate)}}
                </div>
                <div class="label-input-file-browse">Browse</div>
              </div>
            </label>
            <!--accept=".png,.jpeg,.jpg"-->
            <input type="file" class="form-control rounded-0" [id]="'logo2-' + entity.id" formControlName="logo2"
              (change)="uploadFile($event,'logo2')">
            <hbo-field-validation fieldName="logo2"></hbo-field-validation>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <label [for]="'logo3-' + entity.id" class="col-sm-5 col-form-label">
          {{ 'SETTING.LOGO' | translate }} 3
          <hbo-field-info-icon fieldName="webLogo3"></hbo-field-info-icon>
          <a *ngIf="currentSettings.logo[3].image && canEditSettings" (click)="clearImage($event,'logo3')" class="clear-pb"><i
              class="bi bi-trash"></i></a>
          <a *ngIf="currentSettings.logo[3].image" [href]="currentSettings.logo[3].image"
            (click)="showImage($event, currentSettings.logo[3].image)" target="_blank" class="image-link"
            [ngClass]="{'only-image-link':isFormReadOnly}"><i class="bi bi-image"></i></a>
        </label>
        <!--<div class="col-sm-7">
          <input type="file" class="form-control" [id]="'logo3-' + entity.id" formControlName="logo3">
        </div>-->
        <div *ngIf="currentSettings" class="col-sm-7">
          <div class="input-group custom-file-button flex-row-reverse">
            <label class="label-input-file" [for]="'distributorLogo'">
              <div>
                <div class="label-input-file-placeholder">
                  {{ actualFilenames['logo3'] ? actualFilenames['logo3'] : currentSettings.logo[3].image!
                  ? getFileNameFromPath(currentSettings.logo[3].image!,'logo3'):('COMMON.UPLOADIMAGE' | translate)}}
                </div>
                <div class="label-input-file-browse">Browse</div>
              </div>
            </label>
            <!--accept=".png,.jpeg,.jpg"-->
            <input type="file" class="form-control rounded-0" [id]="'logo3-' + entity.id" formControlName="logo3"
              (change)="uploadFile($event,'logo3')">
            <hbo-field-validation fieldName="logo3"></hbo-field-validation>
          </div>
        </div>
      </div>
    </div>

    <div class="col-5 offset-1">
      <div class="mt-4 preview">
        <img [src]="login_svg_thumbnail" [id]="'loginThumbnailLeft-' + entity.id" class="responsive-svg"
          [style.backgroundImage]="loginBackgroundImage" class="background-box" />
        <button type="button" class="btn btn-outline-dark mt-2" (click)="previewLogin()"><i class="bi bi-eye"></i> {{
          'SETTING.PREVIEW' | translate }}</button>
      </div>
    </div>
  </div>

  <div class="row p-4"
    *ngIf="entity.entityTypeId !== 4  || (entity.entityTypeId === 4  && (currentSettings.logo[4]?.configurable || currentSettings.logo[5]?.configurable || currentSettings.logo[6]?.configurable))">
    <div class="col-6">
      <h4 class="pb-2 mb-3 border-bottom fw-bold">{{ 'SETTING.LAYOUT_PAGE' | translate }}</h4>

      <ng-container *ngIf="entity.entityTypeId !== 4">
        <fieldset class="row mb-3">
          <legend class="col-form-label col-sm-5 pt-0">{{ 'SETTING.SIDEBAR_BG' | translate }}</legend>
          <div class="col-sm-7">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" [id]="'sidebarBg1-' + entity.id" formControlName="sidebarBg"
                value="color">
              <label class="form-check-label" [for]="'sidebarBg1-' + entity.id">{{ 'SETTING.COLOR' | translate
                }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" [id]="'sidebarBg2-' + entity.id" formControlName="sidebarBg"
                value="image">
              <label class="form-check-label" [for]="'sidebarBg2-' + entity.id">{{ 'SETTING.IMAGE' | translate
                }}</label>
            </div>
          </div>
        </fieldset>

        <div class="row mb-3">
          <label [for]="'sidebarColor-' + entity.id" class="col-sm-5 col-form-label">{{ 'SETTING.SIDEBAR_BGCOLOR' |
            translate }}</label>
          <div class="col-sm-7">
            <input type="color" class="form-control form-control-color" [id]="'sidebarColor-' + entity.id"
              formControlName="sidebarColor" value="#000">
          </div>
        </div>

        <div class="row mb-3">
          <label [for]="'sidebarImage-' + entity.id" class="col-sm-5 col-form-label">
            {{ 'SETTING.SIDEBAR_IMAGE' | translate }}
            <hbo-field-info-icon fieldName="sidebarImage"></hbo-field-info-icon>
            <a *ngIf="currentSettings.layout.sidebar.backgroundImage && canEditSettings" (click)="clearImage($event,'sidebarImage')"
              class="clear-pb"><i class="bi bi-trash"></i></a>
            <a *ngIf="currentSettings.layout.sidebar.backgroundImage"
              (click)="showImage($event, currentSettings.layout.sidebar.backgroundImage)" target="_blank"
              class="image-link" [ngClass]="{'only-image-link':isFormReadOnly}"><i
                class="bi bi-image"></i></a>
          </label>
          <!--<div class="col-sm-7">
            <input type="file" class="form-control" [id]="'sidebarImage-' + entity.id" formControlName="sidebarImage">
          </div>-->
          <div *ngIf="currentSettings" class="col-sm-7">
            <div class="input-group custom-file-button flex-row-reverse">
              <label class="label-input-file" [for]="'sidebarImage'">
                <div>
                  <div class="label-input-file-placeholder">
                    {{ actualFilenames['sidebarImage'] ? actualFilenames['sidebarImage'] :
                    currentSettings.layout.sidebar.backgroundImage!
                    ?
                    getFileNameFromPath(currentSettings.layout.sidebar.backgroundImage!,'sidebarImage'):('COMMON.UPLOADIMAGE'
                    | translate)}}
                  </div>
                  <div class="label-input-file-browse">Browse</div>
                </div>
              </label>
              <!--accept=".png,.jpeg,.jpg"-->
              <input type="file" class="form-control rounded-0" [id]="'sidebarImage-' + entity.id"
                formControlName="sidebarImage" (change)="uploadFile($event,'sidebarImage')">
              <hbo-field-validation fieldName="sidebarImage"></hbo-field-validation>
            </div>
          </div>
        </div>

        <fieldset class="row mb-3">
          <legend class="col-form-label col-sm-5 pt-0">{{ 'SETTING.SIDEBAR_COLOR' | translate }}</legend>
          <div class="col-sm-7">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" [id]="'sidebarFontColor1-' + entity.id"
                formControlName="sidebarFontColor" value="black">
              <label class="form-check-label" [for]="'sidebarFontColor1-' + entity.id">Black</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" [id]="'sidebarFontColor2-' + entity.id"
                formControlName="sidebarFontColor" value="white">
              <label class="form-check-label" [for]="'sidebarFontColor2-' + entity.id">White</label>
            </div>
          </div>
        </fieldset>
      </ng-container>

      <div class="row mb-3"
        *ngIf="entity.entityTypeId !== 4 || (entity.entityTypeId === 4 && currentSettings.logo[4]?.configurable)">
        <label [for]="'logo4-' + entity.id" class="col-sm-5 col-form-label">
          {{ 'SETTING.LOGO' | translate }} 4
          <hbo-field-info-icon fieldName="webLogo4"></hbo-field-info-icon>
          <a *ngIf="currentSettings.logo[4].image && canEditSettings" (click)="clearImage($event,'logo4')" class="clear-pb"><i
              class="bi bi-trash"></i></a>
          <a *ngIf="currentSettings.logo[4].image" (click)="showImage($event, currentSettings.logo[4].image)"
            target="_blank" class="image-link" [ngClass]="{'only-image-link':isFormReadOnly}"><i
              class="bi bi-image"></i></a>
        </label>
        <!--<div class="col-sm-7">
          <input type="file" class="form-control" [id]="'logo4-' + entity.id" formControlName="logo4">
        </div>-->
        <div *ngIf="currentSettings"
          [ngClass]="{'col-sm-7':entity.entityTypeId !== 4,'col-sm-6':entity.entityTypeId === 4}">
          <div class="input-group custom-file-button flex-row-reverse">
            <label class="label-input-file" [for]="'logo4'">
              <div>
                <div class="label-input-file-placeholder">
                  {{ actualFilenames['logo4'] ? actualFilenames['logo4'] : currentSettings.logo[4].image!
                  ? getFileNameFromPath(currentSettings.logo[4].image!,'logo4'):('COMMON.UPLOADIMAGE' | translate)}}
                </div>
                <div class="label-input-file-browse">Browse</div>
              </div>
            </label>
            <!--accept=".png,.jpeg,.jpg"-->
            <input type="file" class="form-control rounded-0" [id]="'logo4-' + entity.id" formControlName="logo4"
              (change)="uploadFile($event,'logo4')">
            <hbo-field-validation fieldName="logo4"></hbo-field-validation>
          </div>
        </div>
        <div *ngIf="entity.entityTypeId === 4" class="col-sm-1 recover-img-pb" [title]=" 'SETTING.RECOVER' | translate"
          (click)="recoverImage('logo4')">
          <i class="bi bi-arrow-counterclockwise"></i>
        </div>

      </div>

      <div class="form-check mb-3" *ngIf="entity.entityTypeId !== 4">
        <input class="form-check-input" type="checkbox" [id]="'logo4Allow-' + entity.id" formControlName="logo4Allow">
        <label class="form-check-label" [for]="'logo4Allow-' + entity.id">
          {{ 'SETTING.ALLOW' | translate }} (4)
        </label>
      </div>

      <div class="row mb-3"
        *ngIf="entity.entityTypeId !== 4 || (entity.entityTypeId === 4 && currentSettings.logo[5]?.configurable)">
        <label [for]="'logo5-' + entity.id" class="col-sm-5 col-form-label">
          {{ 'SETTING.LOGO' | translate }} 5
          <hbo-field-info-icon fieldName="webLogo5"></hbo-field-info-icon>
          <a *ngIf="currentSettings.logo[5].image && canEditSettings" (click)="clearImage($event,'logo5')" class="clear-pb"><i
              class="bi bi-trash"></i></a>
          <a *ngIf="currentSettings.logo[5].image" (click)="showImage($event, currentSettings.logo[5].image)"
            target="_blank" class="image-link" [ngClass]="{'only-image-link':isFormReadOnly}"><i
              class="bi bi-image"></i></a>
        </label>
        <!--<div class="col-sm-7">
          <input type="file" class="form-control" [id]="'logo5-' + entity.id" formControlName="logo5">
        </div>-->
        <div *ngIf="currentSettings"
          [ngClass]="{'col-sm-7':entity.entityTypeId !== 4,'col-sm-6':entity.entityTypeId === 4}">
          <div class="input-group custom-file-button flex-row-reverse">
            <label class="label-input-file" [for]="'logo5'">
              <div>
                <div class="label-input-file-placeholder">
                  {{ actualFilenames['logo5'] ? actualFilenames['logo5'] : currentSettings.logo[5].image!
                  ? getFileNameFromPath(currentSettings.logo[5].image!,'logo5'):('COMMON.UPLOADIMAGE' | translate)}}
                </div>
                <div class="label-input-file-browse">Browse</div>
              </div>
            </label>
            <!--accept=".png,.jpeg,.jpg"-->
            <input type="file" class="form-control rounded-0" [id]="'logo5-' + entity.id" formControlName="logo5"
              (change)="uploadFile($event,'logo5')">
            <hbo-field-validation fieldName="logo5"></hbo-field-validation>
          </div>
        </div>
        <div *ngIf="entity.entityTypeId === 4" class="col-sm-1 recover-img-pb" [title]=" 'SETTING.RECOVER' | translate"
          (click)="recoverImage('logo5')">
          <i class="bi bi-arrow-counterclockwise"></i>
        </div>
      </div>

      <div class="form-check mb-3" *ngIf="entity.entityTypeId !== 4">
        <input class="form-check-input" type="checkbox" [id]="'logo5Allow-' + entity.id" formControlName="logo5Allow">
        <label class="form-check-label" [for]="'logo5Allow-' + entity.id">
          {{ 'SETTING.ALLOW' | translate }} (5)
        </label>
      </div>

      <div class="row mb-3"
        *ngIf="entity.entityTypeId !== 4 || (entity.entityTypeId === 4 && currentSettings.logo[6]?.configurable)">
        <label [for]="'logo6-' + entity.id" class="col-sm-5 col-form-label">
          {{ 'SETTING.LOGO' | translate }} 6
          <hbo-field-info-icon fieldName="webLogo6"></hbo-field-info-icon>
          <a *ngIf="currentSettings.logo[6].image && canEditSettings" (click)="clearImage($event,'logo6')" class="clear-pb"><i
              class="bi bi-trash"></i></a>
          <a *ngIf="currentSettings.logo[6].image" (click)="showImage($event, currentSettings.logo[6].image)"
            target="_blank" class="image-link" [ngClass]="{'only-image-link':isFormReadOnly}"><i
              class="bi bi-image"></i></a>
        </label>
        <!--<div class="col-sm-7">
          <input type="file" class="form-control" [id]="'logo6-' + entity.id" formControlName="logo6">
        </div>-->
        <div *ngIf="currentSettings"
          [ngClass]="{'col-sm-7':entity.entityTypeId !== 4,'col-sm-6':entity.entityTypeId === 4}">
          <div class="input-group custom-file-button flex-row-reverse">
            <label class="label-input-file" [for]="'logo6'">
              <div>
                <div class="label-input-file-placeholder">
                  {{ actualFilenames['logo6'] ? actualFilenames['logo6'] : currentSettings.logo[6].image!
                  ? getFileNameFromPath(currentSettings.logo[6].image!,'logo6'):('COMMON.UPLOADIMAGE' | translate)}}
                </div>
                <div class="label-input-file-browse">Browse</div>
              </div>
            </label>
            <!--accept=".png,.jpeg,.jpg"-->
            <input type="file" class="form-control rounded-0" [id]="'logo6-' + entity.id" formControlName="logo6"
              (change)="uploadFile($event,'logo6')">
            <hbo-field-validation fieldName="logo6"></hbo-field-validation>
          </div>
        </div>
        <div *ngIf="entity.entityTypeId === 4" class="col-sm-1 recover-img-pb" [title]=" 'SETTING.RECOVER' | translate"
          (click)="recoverImage('logo6')">
          <i class="bi bi-arrow-counterclockwise"></i>
        </div>
      </div>

      <div class="form-check mb-3" *ngIf="entity.entityTypeId !== 4">
        <input class="form-check-input" type="checkbox" [id]="'logo6Allow-' + entity.id" formControlName="logo6Allow">
        <label class="form-check-label" [for]="'logo6Allow-' + entity.id">
          {{ 'SETTING.ALLOW' | translate }} (6)
        </label>
      </div>

    </div>

    <div class="col-5 offset-1">
      <div class="mt-4 preview">
        <!--<object data="assets/images/preview/layout.svg" [id]="'layoutThumbnail-' + entity.id"></object>-->
        <img [src]="sidebar_svg_layout" [id]="'layoutThumbnail-' + entity.id" class="responsive-svg"
          [style.backgroundImage]="sideBarBackgroundImage" class="background-box-layout" />
        <button type="button" class="btn btn-outline-dark mt-2" (click)="preview('layout')"><i class="bi bi-eye"></i> {{
          'SETTING.PREVIEW' | translate }}</button>
      </div>
    </div>
  </div>

  <!-- Dashboard Card -->
  <!-- Role and profile filters live in canEditDashboard, so viewers get it read only -->
  <div class="row p-4" *ngIf="showDashboardSection">
    <div class="col-6">
      <h4 class="pb-2 mb-3 border-bottom fw-bold">{{ 'SETTING.DASHBOARD_CARD.TITLE' | translate }}</h4>

      <!-- Shared colors -->
      <ng-container>
        <div class="row mb-3">
          <label [for]="'dashboardCardHeaderColor-' + entity.id" class="col-sm-5 col-form-label">{{ 'SETTING.DASHBOARD_CARD.HEADER_COLOR' | translate }}</label>
          <div class="col-sm-7">
            <!-- Not bound with formControlName: a null colour has to show the card default, not black -->
            <input type="color" class="form-control form-control-color" [id]="'dashboardCardHeaderColor-' + entity.id"
              [value]="dashboardColorPickerValue('dashboardCardHeaderColor', utils.DASHBOARD_CARD_DEFAULT_HEADER_COLOR)"
              [disabled]="isDashboardColorDisabled('dashboardCardHeaderColor')"
              (input)="onDashboardColorPicked('dashboardCardHeaderColor', $event)">
          </div>
        </div>
        <div class="row mb-4">
          <label [for]="'dashboardCardOutlineColor-' + entity.id" class="col-sm-5 col-form-label">{{ 'SETTING.DASHBOARD_CARD.OUTLINE_COLOR' | translate }}</label>
          <div class="col-sm-7">
            <input type="color" class="form-control form-control-color" [id]="'dashboardCardOutlineColor-' + entity.id"
              [value]="dashboardColorPickerValue('dashboardCardOutlineColor', utils.DASHBOARD_CARD_DEFAULT_OUTLINE_COLOR)"
              [disabled]="isDashboardColorDisabled('dashboardCardOutlineColor')"
              (input)="onDashboardColorPicked('dashboardCardOutlineColor', $event)">
          </div>
        </div>
      </ng-container>

      <!-- Per-card images: Mimesys -->
      <ng-container *ngIf="mimesysAvailable">
        <h6 class="pb-1 mb-3 border-bottom text-muted">Vr App</h6>
        <ng-container *ngTemplateOutlet="cardImageFields; context: {
          cardKey: 'Mimesys',
          headerLogoControl: 'dashboardCardMimesysHeaderLogo',
          bodyImageControl: 'dashboardCardMimesysBodyImage',
          currentHeaderLogo: currentSettings?.dashboard?.card?.mimesys?.headerLogoImage,
          currentBodyImage: currentSettings?.dashboard?.card?.mimesys?.bodyImage
        }"></ng-container>
      </ng-container>

      <!-- Per-card images: FIT -->
      <ng-container *ngIf="fitAvailable">
        <h6 class="pb-1 mb-3 border-bottom text-muted">FIT</h6>
        <ng-container *ngTemplateOutlet="cardImageFields; context: {
          cardKey: 'Fit',
          headerLogoControl: 'dashboardCardFitHeaderLogo',
          bodyImageControl: 'dashboardCardFitBodyImage',
          currentHeaderLogo: currentSettings?.dashboard?.card?.fit?.headerLogoImage,
          currentBodyImage: currentSettings?.dashboard?.card?.fit?.bodyImage
        }"></ng-container>
      </ng-container>

      <!-- Per-card images: 360Depict -->
      <ng-container *ngIf="depict360Available">
        <h6 class="pb-1 mb-3 border-bottom text-muted">Thickness Comparison</h6>
        <ng-container *ngTemplateOutlet="cardImageFields; context: {
          cardKey: 'Depict360',
          headerLogoControl: 'dashboardCardDepict360HeaderLogo',
          bodyImageControl: 'dashboardCardDepict360BodyImage',
          currentHeaderLogo: currentSettings?.dashboard?.card?.depict360?.headerLogoImage,
          currentBodyImage: currentSettings?.dashboard?.card?.depict360?.bodyImage
        }"></ng-container>
      </ng-container>

      <!-- Allow child entities to configure dashboard.-->
      <div class="form-check mb-3" *ngIf="showAllowConfigure">
        <input class="form-check-input" type="checkbox" [id]="'dashboardAllowConfigure-' + entity.id"
          formControlName="dashboardAllowConfigure">
        <label class="form-check-label" [for]="'dashboardAllowConfigure-' + entity.id">
          {{ 'SETTING.DASHBOARD_CARD.ALLOW_CONFIGURE' | translate }}
        </label>
      </div>

    </div>

    <div class="col-5 offset-1">
      <div class="mt-4 preview">
        <img *ngIf="dashboardPreviewThumbnail" [src]="dashboardPreviewThumbnail"
          class="dashboard-preview-thumbnail" alt="" />
        <button type="button" class="btn btn-outline-dark mt-2" (click)="previewDashboardCards()">
          <i class="bi bi-eye"></i> {{ 'SETTING.PREVIEW' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Template: card image fields (reused for each card) -->
  <ng-template #cardImageFields let-cardKey="cardKey"
    let-headerLogoControl="headerLogoControl" let-bodyImageControl="bodyImageControl"
    let-currentHeaderLogo="currentHeaderLogo" let-currentBodyImage="currentBodyImage">

    <div class="row mb-3">
      <label [for]="headerLogoControl + '-' + entity.id" class="col-sm-5 col-form-label">
        {{ 'SETTING.DASHBOARD_CARD.HEADER_LOGO' | translate }}
        <hbo-field-info-icon [fieldName]="headerLogoControl"></hbo-field-info-icon>
        <a *ngIf="currentHeaderLogo && canEditDashboard" (click)="clearImage($event, headerLogoControl)"
          class="clear-pb"><i class="bi bi-trash"></i></a>
        <a *ngIf="currentHeaderLogo"
          (click)="showImage($event, currentHeaderLogo)" class="image-link"
          [ngClass]="{'only-image-link':!canEditDashboard}"><i class="bi bi-image"></i></a>
      </label>
      <div *ngIf="currentSettings" class="col-sm-7">
        <div class="input-group custom-file-button flex-row-reverse">
          <label class="label-input-file" [for]="headerLogoControl">
            <div>
              <div class="label-input-file-placeholder">
                {{ actualFilenames[headerLogoControl] ? actualFilenames[headerLogoControl] :
                currentHeaderLogo ? getFileNameFromPath(currentHeaderLogo, headerLogoControl) : ('COMMON.UPLOADIMAGE' | translate) }}
              </div>
              <div class="label-input-file-browse">Browse</div>
            </div>
          </label>
          <input type="file" class="form-control rounded-0" [id]="headerLogoControl + '-' + entity.id"
            [formControlName]="headerLogoControl" (change)="uploadFile($event, headerLogoControl)">
          <hbo-field-validation [fieldName]="headerLogoControl"></hbo-field-validation>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <label [for]="bodyImageControl + '-' + entity.id" class="col-sm-5 col-form-label">
        {{ 'SETTING.DASHBOARD_CARD.BODY_IMAGE' | translate }}
        <hbo-field-info-icon [fieldName]="bodyImageControl"></hbo-field-info-icon>
        <a *ngIf="currentBodyImage && canEditDashboard" (click)="clearImage($event, bodyImageControl)"
          class="clear-pb"><i class="bi bi-trash"></i></a>
        <a *ngIf="currentBodyImage"
          (click)="showImage($event, currentBodyImage)" class="image-link"
          [ngClass]="{'only-image-link':!canEditDashboard}"><i class="bi bi-image"></i></a>
      </label>
      <div *ngIf="currentSettings" class="col-sm-7">
        <div class="input-group custom-file-button flex-row-reverse">
          <label class="label-input-file" [for]="bodyImageControl">
            <div>
              <div class="label-input-file-placeholder">
                {{ actualFilenames[bodyImageControl] ? actualFilenames[bodyImageControl] :
                currentBodyImage ? getFileNameFromPath(currentBodyImage, bodyImageControl) : ('COMMON.UPLOADIMAGE' | translate) }}
              </div>
              <div class="label-input-file-browse">Browse</div>
            </div>
          </label>
          <input type="file" class="form-control rounded-0" [id]="bodyImageControl + '-' + entity.id"
            [formControlName]="bodyImageControl" (change)="uploadFile($event, bodyImageControl)">
          <hbo-field-validation [fieldName]="bodyImageControl"></hbo-field-validation>
        </div>
      </div>
    </div>

  </ng-template>

  <!-- User Creation Method & Mail Sender -->
  <div *ngIf="entity.entityTypeId !== 4" class="row p-4">
    <div class="col-6">
      <h4 class="pb-2 mb-3 border-bottom fw-bold">{{ 'SETTING.USERCREATIONMETHOD.TITLE' | translate }}</h4>
      <ul class="mb-3 ps-3">
        <li class="mb-1"><strong>{{ 'SETTING.USERCREATIONMETHOD.AUTO' | translate }}</strong>: {{ 'SETTING.USERCREATIONMETHOD.AUTO_DESC' | translate }}</li>
        <li><strong>{{ 'SETTING.USERCREATIONMETHOD.TWOSTEP' | translate }}</strong>: {{ 'SETTING.USERCREATIONMETHOD.TWOSTEP_DESC' | translate }}</li>
      </ul>
      <div class="row mb-3">
        <label class="col-sm-12 col-form-label">{{ 'SETTING.USERCREATIONMETHOD.LABEL' | translate }}</label>
      </div>
      <div class="mb-3">
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" [id]="'ucmAuto-' + entity.id"
            formControlName="sendPasswordEmail" [value]="true">
          <label class="form-check-label" [for]="'ucmAuto-' + entity.id">
            {{ 'SETTING.USERCREATIONMETHOD.AUTO' | translate }}
          </label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" [id]="'ucmTwoStep-' + entity.id"
            formControlName="sendPasswordEmail" [value]="false">
          <label class="form-check-label" [for]="'ucmTwoStep-' + entity.id">
            {{ 'SETTING.USERCREATIONMETHOD.TWOSTEP' | translate }}
          </label>
        </div>
      </div>
      <div class="form-check mb-3" *ngIf="user.roleId === 1 && entity.entityTypeId === 2">
        <input class="form-check-input" type="checkbox" [id]="'allowSendPasswordEmail-' + entity.id"
          formControlName="sendPasswordEmailConfigurable">
        <label class="form-check-label" [for]="'allowSendPasswordEmail-' + entity.id">
          {{ 'SETTING.ALLOWSENDPASSWORDEMAIL' | translate }}
        </label>
      </div>
    </div>

    <div class="col-5 offset-1">
      <h4 class="pb-2 mb-3 border-bottom fw-bold">{{ 'SETTING.MAILSENDERFROM.TITLE' | translate }}</h4>
      <p class="mb-3">{{ 'SETTING.MAILSENDERFROM.DESCRIPTION' | translate }}</p>
      <div class="row mb-3">
        <label [for]="'fromMail-' + entity.id" class="col-sm-5 col-form-label">{{ 'SETTING.FROMMAIL' | translate }}</label>
        <div class="col-sm-7">
          <input type="text" class="form-text-input" [id]="'fromMail-' + entity.id" formControlName="fromMail">
          <hbo-field-validation fieldName="fromMail"></hbo-field-validation>
        </div>
      </div>
      <div class="form-check mb-3" *ngIf="user.roleId === 1 && entity.entityTypeId === 2">
        <input class="form-check-input" type="checkbox" [id]="'fromMailAllow-' + entity.id"
          formControlName="fromMailAllow">
        <label class="form-check-label" [for]="'fromMailAllow-' + entity.id">
          {{ 'SETTING.ALLOWFROMMAIL' | translate }}
        </label>
      </div>
    </div>
  </div>
  <div class="p-4" *ngIf="canEditSettings">
    <button type="button" class="btn btn-outline-secondary me-2" (click)="cancel()">{{ 'COMMON.CANCEL' | translate
      }}</button>
    <button type="submit" class="btn btn-dark"
      [disabled]="settingsForm.controls.fromMail.invalid">{{ 'COMMON.SAVE_CHANGES' |
      translate }}</button>
  </div>
</form>

<!-- Dashboard Card Preview Overlay -->
<div class="dashboard-card-preview-overlay"
     *ngIf="isDashboardPreviewVisible && currentSettings"
     (click)="isDashboardPreviewVisible = false">

  <div class="dashboard-card-preview-panel" (click)="$event.stopPropagation()">

    <button type="button" class="btn-close dashboard-card-preview-close"
            (click)="isDashboardPreviewVisible = false">
    </button>

    <h5 class="mb-4">{{ 'SETTING.DASHBOARD_CARD.TITLE' | translate }} — {{ 'SETTING.PREVIEW' | translate }}</h5>

    <div class="dashboard-card-preview-cards">

      <div class="dashboard-card-preview-col" *ngIf="mimesysAvailable">
        <p class="preview-card-label">Mimesys</p>
        <hbo-dashboard-card
          [headerColor]="settingsForm.get('dashboardCardHeaderColor')?.value ?? null"
          [outlineColor]="settingsForm.get('dashboardCardOutlineColor')?.value ?? null"
          [headerLogoImage]="currentSettings?.dashboard?.card?.mimesys?.headerLogoImage ?? null"
          [bodyImage]="currentSettings?.dashboard?.card?.mimesys?.bodyImage ?? null"
          [ctaText]="'COMMON.VIEW_RESULT' | translate">
        </hbo-dashboard-card>
      </div>

      <div class="dashboard-card-preview-col" *ngIf="fitAvailable">
        <p class="preview-card-label">InVision FIT</p>
        <hbo-dashboard-card
          [headerColor]="settingsForm.get('dashboardCardHeaderColor')?.value ?? null"
          [outlineColor]="settingsForm.get('dashboardCardOutlineColor')?.value ?? null"
          [headerLogoImage]="currentSettings?.dashboard?.card?.fit?.headerLogoImage ?? null"
          [bodyImage]="currentSettings?.dashboard?.card?.fit?.bodyImage ?? null"
          [ctaText]="'COMMON.VIEW_RESULT' | translate">
        </hbo-dashboard-card>
      </div>

      <div class="dashboard-card-preview-col" *ngIf="depict360Available">
        <p class="preview-card-label">360Depict</p>
        <hbo-dashboard-card
          [headerColor]="settingsForm.get('dashboardCardHeaderColor')?.value ?? null"
          [outlineColor]="settingsForm.get('dashboardCardOutlineColor')?.value ?? null"
          [headerLogoImage]="currentSettings?.dashboard?.card?.depict360?.headerLogoImage ?? null"
          [bodyImage]="currentSettings?.dashboard?.card?.depict360?.bodyImage ?? null"
          [ctaText]="'FIT.3D' | translate">
        </hbo-dashboard-card>
      </div>

    </div>
  </div>
</div>